// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-chat-jsx": () => import("./../src/pages/chat.jsx" /* webpackChunkName: "component---src-pages-chat-jsx" */),
  "component---src-pages-index-jsx": () => import("./../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

